import React from 'react';
import { UrbanZaikhaLogo } from './Logo';

const Loader: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-[#0c1a18] flex items-center justify-center z-50">
      <div className="animate-pulse">
        <UrbanZaikhaLogo size="large" />
      </div>
    </div>
  );
};

export default Loader;
